import { COOKIE_KEYS } from '../../constants/app-constants';
import parseCookie from './parse-cookie';
import { parseLocationSearchParams } from './parse-location-search-params';

const getAccessToken = () => {
    const tokenFromUrl = parseLocationSearchParams(window?.location?.search)?.token;

    if (tokenFromUrl) {
        return tokenFromUrl;
    }

    return parseCookie(COOKIE_KEYS.ACCESS_TOKEN) || null;
};

export default getAccessToken;
